import { env } from "../../utils/env";

export const REPORT_GENERATED =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? "Reporting.PublishedLanguage.Events.ReportGenerated"
    : "Charisma.Leasing.PublishedLanguage.Events.Report.ReportGenerated";
export const REPORT_LOOKUP_DS_FOUND =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? "Reporting.PublishedLanguage.Events.ReportLookupDataSourceLoaded"
    : "Charisma.Leasing.PublishedLanguage.Events.Report.ReportLookupDataSourceLoaded";
export const REPORT_BROWSER_LOADED =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? "Reporting.PublishedLanguage.Events.ReportBrowserLoaded"
    : "Charisma.Leasing.PublishedLanguage.Events.Report.ReportBrowserLoaded";
export const REPORT_BROWSERDATA_LOADED =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? "Reporting.PublishedLanguage.Events.ReportBrowserDataLoaded"
    : "Charisma.Leasing.PublishedLanguage.Events.Report.ReportBrowserDataLoaded";
export const BROWSER_LOOKUP_DS_FOUND =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? "Reporting.PublishedLanguage.Events.BrowserLookupDataSourceLoaded"
    : "Charisma.Leasing.PublishedLanguage.Events.Report.BrowserLookupDataSourceLoaded";
